export default __webpack_public_path__ + "static/media/slide-campain1.d2062bcc.png";